import "./home.scss";
import { allImages } from "../../services/images";
import { Carousel } from "react-bootstrap";
import { HiArrowCircleRight } from "react-icons/hi";
import { Accordion, useAccordionButton } from "react-bootstrap";
import { useAppSelector } from "../../Redux/hook";
import { Heading, Counter, FiveStarRating } from "../../components/Reusable/resuable";
import { useNavigate } from "react-router-dom";
import { Services } from "../../models/models";
import { services, testimonials } from "../../services/data";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { ImageGallery } from "../../services/DataFiles/Gallery/Imagegallery";
import clientImages from "../../services/clientsImage";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function Home() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    const navigate = useNavigate();
    function CarouselItem({ image = "", text = "", head = "" }) {
        return (
            <div className="carousel">
                <img src={image} alt={"crl"} />
                <div className="guard"></div>
                <div className="head">
                    {head === "" ? <div>Welcome to <span>PBL</span>
                        <div>Transport Corporation</div>
                        <div>Private Limited</div></div> : <div>{head}</div>}
                    <div className="subtext">{text}</div>
                </div>
            </div>
        );
    }
    function CommentCard({ index = 0 }) {
        return <div className="tcard">
            <div className="image">
                <img src={testimonials[index].logo} alt="mantena" />
                <div className="name">{testimonials[index].name}</div>
            </div>
            <div>
                <div className="left"><FaQuoteLeft /><FiveStarRating /></div>
                <div className="para">{testimonials[index].comment}</div>
                <FaQuoteRight className="right" />
            </div>
        </div>
    }
    function CardItem(service: Services) {
        function nav() {
            localStorage.setItem('servicetype', service.id.toString())
            navigate("/mainService");
        }
        return (
            <div onClick={nav} className={!lightMode ? "cards cardDark headDark" : "cards cardLight headLight"}>
                <div>
                    <div className="arrowIcon"><HiArrowCircleRight size={60} color="" /></div>
                    <div className="head">{service.heading}</div>
                    <h6>{service.tagline}</h6>
                </div>
                <div className="img">
                    <img src={service.image} alt="trailer" className="mt-2" />
                    <div className="ho"></div>
                </div>
            </div>
        );
    }

    var clients = [
        {
            logo: clientImages.abb,
            name: "Asea Brown Boveri LTD"
        },
        {
            logo: clientImages.enmas,
            name: "Enmas Andritz Private Limited"
        },
        {
            logo: clientImages.bpl,
            name: "Bharat Petroleum"
        },
        {
            logo: clientImages.cairn,
            name: "Cairn Energy India "
        },
        {
            logo: clientImages.bhel,
            name: "Bharat Heavy Electrical Limited"
        },
        {
            logo: clientImages.nav,
            name: "China National Petroleum Corporation"
        },
    ];
    var clients1 = [
        {
            logo: clientImages.tatapro,
            name: "Tata Projects Limited"
        },
        {
            logo: clientImages.ongc,
            name: "OIL AND NATURAL GAS CORPORATION LTD"
        },
        {
            logo: clientImages.sanghvi,
            name: "Sanghvi Movers Limited"
        },
        {
            logo: clientImages.SAIL_LOGO_NEW,
            name: "STEEL AUTHORITY OF INDIA LTD"
        },
        {
            logo: clientImages.jindal,
            name: "JINDAL STEEL AND POWER LIMITED"
        },
        {
            logo: clientImages.pillogo,
            name: "Pipeline Infrastructure Limited(Ap)"
        },
    ];
    var faq = [
        {
            question: "Are there any special considerations for ODC routes?",
            answer: "<p>Yes, ODC transportation requires careful route planning, and several factors need to be considered:</p><ul><li><strong>Bridge and Road Load Limits:</strong> Ensuring the weight is within allowable limits for bridges and roads.</li><li><strong>Tunnel and Height Clearance:</strong> Checking for clearance in tunnels and overpasses.</li><li><strong>Turning Radii:</strong> Ensuring the load can safely navigate turns, especially on narrow roads.</li><li><strong>Local Regulations:</strong> Adhering to specific rules that vary by jurisdiction (e.g., time-of-day restrictions or local traffic conditions).</li><li><strong>Pilot Cars or Escorts:</strong> For safe navigation, pilot vehicles may be required to lead the convoy, alerting traffic and ensuring smooth passage.</li></ul>"
        },
        {
            "question": "What are the costs involved in ODC transportation?",
            "answer": "<p>The cost of transporting ODC can be higher than regular cargo due to several factors:</p><ul><li><strong>Special Equipment:</strong> Using cranes, multi-axle trailers, or other specialized vehicles.</li><li><strong>Permitting Fees:</strong> Obtaining necessary permits for oversized cargo transport.</li><li><strong>Escort Vehicle Costs:</strong> Costs for pilot cars or police escorts.</li><li><strong>Route Surveys:</strong> Pre-transport planning to assess road conditions and clearances.</li><li><strong>Delays:</strong> Potential detours or delays due to weather conditions, roadblocks, or regulatory requirements.</li></ul>"
        },
        {
            "question": "How do you ensure the safety of my cargo during transportation?",
            "answer": "<p>We prioritize the safety of your cargo through the following measures:</p><ul><li><strong>Pre-Transport Inspections:</strong> Thorough checks of both the equipment and cargo before transport.</li><li><strong>Proper Rigging & Securing:</strong> Ensuring the cargo is safely secured for transport.</li><li><strong>Certified Operators:</strong> Using experienced and certified crane operators and truck drivers.</li><li><strong>Weather Monitoring:</strong> Avoiding unsafe conditions by monitoring weather patterns.</li><li><strong>Real-Time Tracking:</strong> Keeping you updated with live tracking of your shipment.</li><li><strong>Cargo Insurance:</strong> Offering insurance options to protect your goods during transit.</li></ul>"
        },
        {
            "question": "What should I do to prepare my cargo for transport?",
            "answer": "<p>To ensure smooth transportation, please take the following steps to prepare your cargo:</p><ul><li><strong>Proper Packing & Securing:</strong> Ensure your cargo is safely packed and secured for the journey.</li><li><strong>Consult Rigging Experts:</strong> For large or heavy equipment, work with our rigging specialists to determine the best way to secure your load.</li><li><strong>Follow Guidelines:</strong> Our team will provide specific guidelines on how to prepare different types of cargo for safe transport.</li></ul>"
        },
        {
            "question": "What is a Prime Mover?",
            "answer": "<p>A prime mover is a powerful vehicle designed to tow heavy loads. Here are some important details:</p><ul><li><strong>Purpose & Design:</strong><ul><li>Primarily used for towing trailers and hauling heavy freight over long distances.</li><li>Engineered with a robust engine and chassis to handle significant weight, focusing on torque and power output.</li></ul></li><li><strong>Components:</strong><ul><li><strong>Engine:</strong> Typically a powerful diesel engine that provides the necessary horsepower and torque.</li><li><strong>Cab:</strong> Houses the driver and may include features like sleeper compartments for long hauls.</li><li><strong>Fifth Wheel:</strong> The coupling device on the tractor that connects to the trailer.</li></ul></li><li><strong>Types of Prime Movers:</strong><ul><li><strong>Single-Drive:</strong> One set of drive wheels for lighter loads.</li><li><strong>Dual-Drive:</strong> Two sets of drive wheels for heavier or off-road loads.</li></ul></li><li><strong>Applications:</strong><ul><li><strong>Freight Transport:</strong> Used for moving goods across regions and countries.</li><li><strong>Construction & Mining:</strong> Used to haul equipment and materials.</li></ul></li><li><strong>Advantages:</strong><ul><li><strong>Versatility:</strong> Can be used with various trailer types (flatbeds, refrigerated, tankers).</li><li><strong>Efficiency:</strong> Ideal for long-distance travel, offering a cost-effective transport solution.</li></ul></li></ul>"
        },
        {
            "question": "What information do I need when hiring a crane service?",
            "answer": "<p>To provide an accurate estimate and ensure the correct equipment is used, please have the following information ready:</p><ul><li><strong>Weight & Dimensions of the Item(s):</strong> Helps us determine the rigging specifications and crane size needed.</li><li><strong>Obstructions:</strong> Any obstacles (e.g., trees, buildings, power lines) the crane will need to work around.</li><li><strong>Lift & Set Elevations:</strong> The height at which the item will be lifted and where it will be set.</li><li><strong>Access Restrictions:</strong> If the site has restricted access, we need to know how to prepare the area (e.g., matting for crane setup).</li><li><strong>Project Location:</strong> This helps determine permitting needs and travel logistics.</li><li><strong>Load Value:</strong> If your load exceeds the standard insurance coverage, let us know so we can offer additional protection.</li></ul>"
        },
        {
            "question": "What are the main types of heavy cranes?",
            "answer": "<p>Heavy cranes are essential for lifting and moving large and heavy loads in construction, infrastructure, and industrial sectors. Here are the main types of heavy cranes:</p><ol><li><strong>Crawler Cranes</strong><br><strong>Description:</strong> These cranes are mounted on a set of tracks or crawlers, which allow them to move over rough terrain without the need for a road.<br><strong>Uses:</strong> Typically used for large, heavy lifts on construction sites, especially in rough or soft ground areas.<br><strong>Advantages:</strong> High stability, can work in difficult terrain, and do not need a separate transport vehicle.</li><li><strong>Truck-Mounted Cranes</strong><br><strong>Description:</strong> These cranes are mounted on a truck chassis and can travel on highways without the need for special transport.<br><strong>Uses:</strong> Often used in applications that require mobility and the ability to travel between job sites, such as for roadwork or in urban environments.<br><strong>Advantages:</strong> High mobility, easy to set up, and can be moved quickly from one location to another.</li><li><strong>Rough Terrain Cranes</strong><br><strong>Description:</strong> These cranes are designed with large, knobby tires and are optimized for rough, uneven ground.<br><strong>Uses:</strong> Commonly used in construction, oil rigs, and mining operations where the crane needs to move over rough surfaces.<br><strong>Advantages:</strong> Mobility over rough terrain, quick setup, and suitable for off-road use.</li><li><strong>All-Terrain Cranes</strong><br><strong>Description:</strong> These cranes combine the features of both truck-mounted and rough terrain cranes. They can travel on highways and off-road with ease.<br><strong>Uses:</strong> Used for projects that need mobility and are located in areas with rough terrain or require transportation over long distances.<br><strong>Advantages:</strong> High versatility, can travel on both paved roads and rough terrain, and quick setup time.</li><li><strong>Lattice Boom Cranes</strong><br><strong>Description:</strong> These cranes have a lattice structure on the boom, making them strong and capable of handling very heavy loads.<br><strong>Uses:</strong> Often used for large infrastructure projects like bridges, ports, and industrial facilities.<br><strong>Advantages:</strong> Ability to lift extremely heavy loads and reach high elevations.</li><li><strong>Telescopic Cranes</strong><br><strong>Description:</strong> These cranes have a boom that can extend and retract, allowing for various working heights and reach.<br><strong>Uses:</strong> Common in construction, maintenance, and rescue operations where a quick and adjustable reach is necessary.<br><strong>Advantages:</strong> Compact and versatile, easy to transport, and quick to deploy.</li><li><strong>Overhead Cranes (Bridge Cranes)</strong><br><strong>Description:</strong> These cranes are mounted on tracks above the workspace, allowing them to lift loads within a defined area.<br><strong>Uses:</strong> Commonly found in factories, warehouses, and shipping yards.<br><strong>Advantages:</strong> Space-saving design, capable of lifting heavy loads without occupying the floor space.</li><li><strong>Hydraulic Cranes</strong><br><strong>Description:</strong> These cranes use hydraulic systems to lift loads, providing power to the crane's boom and lifting mechanism.<br><strong>Uses:</strong> Versatile cranes used in various industries such as construction, industrial maintenance, and logistics.<br><strong>Advantages:</strong> Powerful lifting capabilities with smooth operation and easy control.</li></ol><p>These types of heavy cranes are designed for different purposes depending on the environment and nature of the work they are needed for.</p>"
        },
        {
            "question": "What Safety Protocols Are Followed When Operating Heavy Machinery?",
            "answer": "<p>Safe operation of heavy machinery demands thorough training, adherence to safety protocols, and consistent use of personal protective equipment (PPE).</p><ul><li><strong>Trained Operators:</strong> PBL Operators are fully trained to understand the machine's capabilities and limitations.</li><li><strong>Personal Protective Equipment (PPE):</strong> Helmets, gloves, and safety glasses are worn at all times.</li><li><strong>Clear Communication:</strong> Effective coordination with ground personnel is critical.</li><li><strong>Load & Speed Limits:</strong> Adhering to load capacities and speed restrictions minimizes risks.</li><li><strong>Regular Safety Reviews:</strong> Safety practices are updated to align with industry standards, ensuring a secure work environment.</li></ul>"
        }
    ];
    function QA({ question = "", eventkey = "", answer = "" }) {
        const clicked = useAccordionButton(eventkey, () => { });
        return <div className={lightMode ? "qa cardLight" : "cardDark qa"} onClick={clicked}>
            <div className="question">{question}<span className="icon">+</span></div>
            <Accordion.Collapse eventKey={eventkey}><div dangerouslySetInnerHTML={{ __html: answer }} /></Accordion.Collapse>
        </div>
    }
    var insights = [
        {
            name: "Years in Business",
            icon: "+",
            value: 35
        },
        {
            name: "Project Completed",
            icon: "+",
            value: 400
        },
        {
            name: "Satisfied Clients",
            icon: "+",
            value: 200
        },
        {
            name: "Skilled Manpower",
            icon: "+",
            value: 500
        },
        {
            name: "Distribution Facilities",
            icon: "+",
            value: 10
        },
        {
            name: "Project Awards",
            icon: "+",
            value: 40
        },
    ]

    const location = useLocation();
    useEffect(() => {
        if (location.hash === "#Testimonials") {
            const target = document.querySelector(location.hash);
            if (target) {
                setTimeout(() => {
                    target.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        }

    }, [location])

    return (
        <div className="home">
            <Helmet>
                <title>Home - PBL Transport</title>
                <meta
                    name="keywords"
                    content="Trailers,cranes,axles,forklifts&manlifts"
                ></meta>
            </Helmet>
            <div className="intro">
                <Carousel controls={true} indicators={true}>
                    <Carousel.Item interval={2000}>
                        <CarouselItem image={allImages.carousel5} text="PBL Group, founded in 1980, aims to deliver top-notch services in handling, transportation, and the hiring of cranes, trailers, forklifts, and manlifts across major Indian cities" />
                    </Carousel.Item>
                    <Carousel.Item interval={2000}>
                        <CarouselItem head="PBL Transport" image={ImageGallery.cranes.TruckCranes[4].image} text=" With a rich legacy, a progressive outlook and a consistently superior track record, the group remains committed towards excellence and delivering satisfaction to its customers. Our group is a dynamic enterprise which draws its support from various individual entities and associates to be able to execute turnkey transportation, project cargo transportation swiftly and efficiently." />
                    </Carousel.Item>
                    <Carousel.Item interval={2000}>
                        <div className="carouselImage ci2">
                            <div className="content">
                                <div className="heads"><span>PBL</span>&nbsp;<span>Transport</span></div>
                                <div className="tagline"><span>Where</span>&nbsp;<span className="words">Strength</span></div>
                                <div className="tagline"><span className="words">Meets</span>&nbsp;<span>Solutions</span></div>
                                <div onClick={() => window.open(allImages.brochure)} className="button">Download Brochure</div>
                            </div>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item interval={2000}>
                        <CarouselItem head="PBL Transport" image={allImages.trailer} text="We continuously evolve our proven processes to stay ahead of the ever-changing market. By fully understanding your unique supply chain needs, we craft personalized solutions that work specifically for you. Challenge us - we're ready to deliver." />
                    </Carousel.Item>
                </Carousel>
            </div>
            <div className={`insights ${lightMode ? "headLight" : ""}`}>
                {insights.map((item, i) => <div className="holder">
                    <Counter val={item.value} icon={item.icon} />
                    <div className="name">{item.name}</div>
                </div>)}
            </div>
            <div className="services">
                <div className="vectors">
                    <img src={allImages.vector1} alt="img" />
                    <img src={allImages.vector2} alt="img" className="mt-8" />
                </div>
                <div className="service">
                    <Heading lightMode={lightMode} heading="OUR SERVICES" />
                    <div className="rows">
                        {
                            services.map((item, i) => {
                                return <CardItem {...item} />
                            })
                        }
                    </div>
                    <div className="clients">
                        <div className="heads mobile"><Heading lightMode={lightMode} heading="OUR CLIENTS" /></div>
                        <div className="threegrid">
                            {
                                clients1.map((item, i) => {
                                    return <div className="adcard left">
                                        <img src={item.logo} alt="abb" />
                                        <span>{item.name}</span>
                                    </div>
                                })
                            }
                        </div>
                        <div className="heads desktop"><Heading lightMode={lightMode} heading="OUR CLIENTS" /></div>
                        <div className="threegrid">
                            {
                                clients.map((item, i) => {
                                    return <div className="adcard right">
                                        <img src={item.logo} alt="abb" />
                                        <span>{item.name}</span>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                    <div className="divider mt-5 mb-5"></div>
                    <div className="testimonials" id="Testimonials">
                        <Heading lightMode={lightMode} heading="Testimonials" />
                        <Carousel controls={true} indicators={true}>
                            <Carousel.Item interval={3000}><CommentCard index={0} /></Carousel.Item>
                            <Carousel.Item interval={3000}><CommentCard index={2} /></Carousel.Item>
                            <Carousel.Item interval={3000}><CommentCard index={5} /></Carousel.Item>
                        </Carousel>
                    </div>
                    <div className="divider mt-5 mb-5"></div>
                    <div className="faqbox">
                        <div className="vectors">
                            <img src={allImages.vector1} alt="img" />
                            <img src={allImages.vector2} alt="img" className="mt-8" />
                        </div>

                        <div className="faq">
                            <div style={{ flex: "1" }}>
                                <h2 className={lightMode ? "headLight" : "headDark"} style={{ borderBottom: "0px", marginBottom: "20px" }}>FAQ'S</h2>
                                <Accordion>
                                    {
                                        faq.map((item, i) => {
                                            return <QA question={item.question} eventkey={i.toString()} answer={item.answer} />
                                        })
                                    }
                                </Accordion>
                            </div>
                            <div className="image">
                                <img src={allImages.faq} alt="faq" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div></div>
        </div>
    );
}